// extracted by mini-css-extract-plugin
export default {"title":"egiLMcQGxEbR6xH9aJTe","rightJustify":"SofmVRYw2oNgegqgdg_F","leftJustify":"kk0K25a7wRitFfv0r0XA"};